import { GridAlpha, Text } from '@applyboard/crystal-ui'

import { format } from 'date-fns'
import { DecisionResponseType } from '@applyboard/school-applications-types-lib'

type ApplicationDetailCardDescriptionProps = Readonly<{
  issuedOn: Date | undefined
  revokedAt?: Date | undefined
  statusChangedOn?: Date
  status: DecisionResponseType | string | undefined
  activeRecord?: boolean
  replacedAt?: Date | undefined
}>

export function ApplicationDetailCardDescription(props: ApplicationDetailCardDescriptionProps) {
  const descriptionItems: { descriptionLabel: string; descriptionValue: string }[] = []

  if (props.issuedOn) {
    descriptionItems.push({
      descriptionLabel: 'Issue date',
      descriptionValue: format(props.issuedOn, 'MMM dd, yyyy'),
    })
  }

  if (props.revokedAt) {
    descriptionItems.push({
      descriptionLabel: 'Revoked date',
      descriptionValue: format(props.revokedAt, 'MMM dd, yyyy'),
    })
  }

  if (
    props.status === DecisionResponseType.ACCEPTED &&
    props.statusChangedOn &&
    props.activeRecord === true &&
    !props.revokedAt
  ) {
    descriptionItems.push({
      descriptionLabel: 'Accepted date',
      descriptionValue: format(props.statusChangedOn, 'MMM dd, yyyy'),
    })
  }

  if (props.activeRecord === false && props.replacedAt) {
    descriptionItems.push({
      descriptionLabel: 'Replaced on',
      descriptionValue: format(props.replacedAt, 'MMM dd, yyyy'),
    })
  }

  return (
    <GridAlpha
      columns={{
        xs: 'auto',
        lg: 'repeat(2, 1fr)',
      }}
      columnGap={20}
      rowGap={6}
    >
      {descriptionItems.map(item => (
        <GridAlpha.Item key={item.descriptionLabel}>
          <Text variant="labelM" contrast="high">
            {item.descriptionLabel}
          </Text>
          <Text variant="bodyM" contrast="mid">
            {item.descriptionValue}
          </Text>
        </GridAlpha.Item>
      ))}
    </GridAlpha>
  )
}
